import React, {Component} from 'react';
import axios from "axios/index";
import { decorate, observable, action, isObservableObject } from 'mobx';
import { observer, inject } from 'mobx-react';
import {Link} from "react-router-dom";
import _ from "underscore";
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import moment from "moment/moment";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import {
  FormGroup,
  FormTextarea,
  FormCheckbox,
  FormSelect,
  Tooltip,
  Modal,
  ModalBody,
  ModalHeader,
  FormInput,
  Button, Col, Row,
  ListGroup, ListGroupItem,
  Popover, PopoverBody, PopoverHeader
} from "shards-react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './style.scss'
import ModalLoading from "../../../components/common/ModalLoading";
import {Common as util} from "../../../utils/common";
import DateTimePicker from "react-datetime-picker";

function isOverThreeMonths(date1, date2) {
  const startDate = moment(date1);
  const endDate = moment(date2);
  const monthsDiff = endDate.diff(startDate, 'months');
  return monthsDiff < 3;
}

function isOverPeriod(date1, date2, periodArr) {
  const startDate = moment(date1);
  const endDate = moment(date2);
  const periodDiff = endDate.diff(startDate, periodArr[1]);
  return periodDiff < periodArr[0];
}

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ common }) => ({ getDoc: common.getDoc, getStoreTotalConfig: common.getStoreTotalConfig, getMsgList: common.getMsgList }))
@inject(({ review }) => ({ getReviewList:review.getReviewList, setReviewSync: review.setReviewSync,
  updateReviewDisplayStatus: review.updateReviewDisplayStatus, updateReviewSome: review.updateReviewSome, updateReviewComment: review.updateReviewComment, genAIComment: review.genAIComment, commentSmartCorrent: review.commentSmartCorrent, adminDelReview:review.adminDelReview,
  getStatusReviewBoard: review.getStatusReviewBoard, downloadFile : review.downloadFile }))
@inject(({ widget }) => ({ getWidgetList:widget.getWidgetList, getWidgetInReviewList:widget.getWidgetInReviewList, updateWidgetInReview: widget.updateWidgetInReview, updateWidgetInReviewOrder: widget.updateWidgetInReviewOrder, removeWidgetInReview: widget.removeWidgetInReview }))
@inject(({ AOA }) => ({ adminCusData:AOA.adminCusData }))


@observer
class MsgList extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //page
  @observable initialGetReviewList = true;
  @observable isShowDetailSearch = true;

  @observable serarchPeriod = [3, "months", "3개월 단위"];
  @observable searchFormValue = {
    searchType: 'all',
    keyword: '',
    // startDate: moment().add(-7, 'days').format('yyyy-MM-DD'),
    // endDate: moment().format('yyyy-MM-DD'),
    startDate: "",
    endDate: "",
    star: {
      all: true,
      star5: true,
      star4: true,
      star3: true,
      star2: true,
      star1: true,
    },
    writer: {
      all: true,
      member: true,
      admin: true,
    },
    reviewType: {
      all: true,
      text: true,
      image: true,
      // movie: true,
      // survey: true,
    },
    reviewDis: {
      all: true,
      on: true,
      will: true,
      pending: true,
    },
    isDelete: false,
    noComment: false
  };
  @observable syncReviewValue = {
    startDate: moment().add(-1, 'days').format('yyyy-MM-DD'),
    endDate: moment().format('yyyy-MM-DD'),
    isOverwrite: false,
  };
  @observable basicSettings = {};

  @observable isShowCalendar = {
    startDate: false,
    endDate: false
  }



  @observable listParams = {
    page:1, limit:25,
    searchParams: { },
    shopNo: 1
  }
  @observable list = {};

  @observable modals = {
    isSyncReview: false,
    data: {}
  };

  constructor(props) {
    super(props);
    this.init()
  }

  @action
  init = async (key) => {

    let _this = this;
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.listParams.store_id = this.teamUser.selStore_id;
      // this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
      this.getDataNeed();
    }


  };


  //ui fn
  getDataNeed = async () => {
    this.list = await this.props.getMsgList(this.listParams);
    this.isLoading = false;
  }

  goToCharge = async () => {
    let url = '/msgOrder';
    window.location.href = url;
  }


  adminCusData = async() => {
    let _this = this;

    let updateData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
    }
    // console.log('updateMassReview', updateData);
    this.props.adminCusData(updateData, function(res) {
      console.log(res);

    });
  }

  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let limit = _this.list.limit || _this.listParams.limit;
      let totalPages = _this.list.totalPages || 0;
      let curPageNum = _this.list.page || _this.listParams.page;
      let nextPage = _this.list.nextPage;
      let prevPage = _this.list.prevPage;
      let startNum = (parseInt((curPageNum-1)/10)*10) +1;
      let endNum = startNum+9 < totalPages ? startNum+9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for(let i = startNum; i <= endNum; i ++) {
          if(i == curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
        }
        return result;
      }

      if(_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                { curPageNum != 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
                { startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page="+(startNum-1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
                {rendering()}
                { endNum != totalPages  ? <li className="btn-page-next"><a href={urlParams + "&page="+(startNum+10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
                { curPageNum != totalPages ? <li className="btn-page-last"><a href={urlParams + "&page="+totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
              </ul>
            </div>);
      }
      else {
        return (<></>);
      }

    }

    return (
      <div className="main-content" >
        <PageTitle />
        {/*<Row  className="mtb-10">*/}
        {/*  <Col xs={12}><Button onClick={event => this.adminCusData()}>커스텀</Button></Col>*/}
        {/*</Row>*/}
        <div className="section-box" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <div className="talk-count" style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
            <span style={{color: '#666'}}>보유 알림톡</span>
            <strong style={{fontSize: '18px', color: '#333'}}>{this.store.messageQuota.toLocaleString() || 0}건</strong>
          </div>
          <div className="btn-charge">
            <Button
                onClick={event => this.goToCharge()}
                style={{
                  padding: '8px 20px',
                  backgroundColor: '#4A90E2',
                  border: 'none',
                  borderRadius: '4px',
                  color: 'white',
                  cursor: 'pointer'
                }}
            >
              충전하기
            </Button>
          </div>
        </div>

        {this.list && this.list.docs ? (
        <div className="review-list-box msg-list-box">
          <form id="reviewListForm" className="review-list-form">
            <div className="section-box review-list-table">
              <table>
                <colgroup>
                  {/*<col width="10%"/>*/}
                  <col/>
                  <col width="12%"/>
                  <col width="15%"/>
                </colgroup>
                <thead>
                <tr>
                  {/*<th><FormCheckbox*/}
                  {/*  // checked={this.state.orange}*/}
                  {/*  // onChange={e => this.handleChange(e, "orange")}*/}
                  {/*>*/}
                  {/*</FormCheckbox></th>*/}
                  {/*<th>타입</th>*/}
                  <th>주문내용</th>
                  <th>주문자</th>
                  <th>발송날짜</th>
                </tr>
                </thead>
                <tbody>
                {this.list && this.list.docs && this.list.docs.length > 0 ?
                  this.list.docs.map((item, i) => (
                      <tr key={i}>
                        {/*<td>{item.messageType}</td>*/}
                        <td>{item.order_id.orderProductName}</td>
                        <td className="text-center">{item.order_id.receiverName}</td>
                        <td>{moment(item.createdAt).format("YYYY-MM-DD hh:mm:ss")}</td>
                      </tr>
                  ))
                    :
                    <tr>
                      <td colSpan={4} className="text-center"><br/><br/>리뷰가 없습니다.<br/><br/><br/></td>
                    </tr>
                }
                </tbody>
              </table>
              <Pagination/>
            </div>
          </form>
        </div>) : null }

        <ModalLoading isLoading={this.isLoading}/>
      </div>
    )
  }
}

export default MsgList;
